import { createSlice } from '@reduxjs/toolkit';
const SLICE_NAME = 'buyAdvertsModalSlice';

export const buyAdvertsModalSlice = createSlice({
    name: SLICE_NAME,
    initialState: {
        isOpen: false,
    },
    reducers: {
        toggleBuyAdvertsModal(state) {
            state.isOpen = !state.isOpen;
        },
    },
});

export const { toggleBuyAdvertsModal } = buyAdvertsModalSlice.actions;

export const buyAdvertsModalStateSelector = (state) => state.buyAdvertsModal.isOpen;

export const buyAdvertsModal = buyAdvertsModalSlice.reducer;
